import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { persist, } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { defaultTabs } from "../Services/strategies/strategyConstants";
import devDebug from "../Helpers/debug";

// define the initial state
const initialState = {
  currentTab: defaultTabs,
  firstTime: false,
  accessToken: null,
  refreshToken: null,
  reloadedOnce: false,
  user: null,
  reloadAfterStripe: false,
  jwtRefreshed: false,
  strategiesNeverRequested: true,
};

const currentAppVersionFromEnv = Number(import.meta.env.VITE_LOGIN_DETAILS_KEY);

export const useAuthStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      setStrategiesNeverRequested: (strategiesNeverRequested) => {
        set((state) => {
          state.strategiesNeverRequested = strategiesNeverRequested;
        })
      },
      setJWTRefreshed: (jwtRefreshed) => {
        set((state) => {
          state.jwtRefreshed = jwtRefreshed;
        })
      },
      setReloadAfterStripe: (reloadAfterStripe) => {
        set((state) => {
          state.reloadAfterStripe = reloadAfterStripe;
        })
      },
      setUser: (user) => {
        set((state) => {
          state.user = user;
        })
      },
      setReloadedOnce: (reloadedOnce) => {
        set((state) => {
          state.reloadedOnce = reloadedOnce;
        })
      },
      setFirstTime: (firstTime) => {
        set((state) => {
          state.firstTime = firstTime;
        })
      },
      setAccessToken: (accessToken) => {
        set((state) => {
          state.accessToken = accessToken;
        })
      },
      setRefreshToken: (refreshToken) => {
        set((state) => {
          state.refreshToken = refreshToken;
        })
      },
      setTabID: (section, id) =>
        set((state) => {
          state.currentTab[section] = `${id}`;
        }),
      resetState: () => {
        useAuthStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) => !["jwtRefreshed"].includes(key)
          )
        ),
      name: "authStore",
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[authStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[authStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[authStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[authStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
    }
  ),
  shallow
);
